import http from '@/utils/http' //引入axios
export const getAlipayUser = data => http.get('/kg-payment/api/alipay/user', {
    params: data
}) //查找Alipay用户
export const ChangeAlipayUser = data => http.put('/kg-payment/api/alipay/user', data) //查找Alipay用户
export const exportCord = data => http.get('/kg-payment/api/alipay/user/excel', {
    params: data,
    responseType: 'blob'
})
export default {
    getAlipayUser,
    ChangeAlipayUser,
    exportCord
}